import React, { useState, useEffect } from "react";
import { Button, Card, Col, Row, Select, Table } from "antd";
import callApi from "../../constants/API/CallApi";
import { branchStats, ListBranch } from "../../constants/API/API";
import useApi from "../../hooks/useApi";

const { Option } = Select;

/* ---------- Helper to format stats ---------- */
const formatStats = (data) => {
  if (!data) return [];
  return [
    { key: "completedBookings", metric: "Completed Bookings", value: data.completedBookings },
    { key: "upcomingBookings", metric: "Upcoming Bookings", value: data.upcomingBookings },
    { key: "totalParents", metric: "Total Parents", value: data.totalParents },
    { key: "totalStudents", metric: "Total Students", value: data.totalStudents },
    { key: "trainers", metric: "Trainers", value: data.trainers },
    { key: "admins", metric: "Admins", value: data.admins },
    { key: "subscriptions", metric: "Approved Subscriptions", value: data.subscriptions },
    { key: "totalSubscription", metric: "Subscribed Parents", value: data.totalSubscription },
    { key: "totalUnSubscription", metric: "Unsubscribed Parents", value: data.totalUnSubscription },
  ];
};

const CompareBranches = () => {
  const [branches, setBranches] = useState([]);
  const [branch1, setBranch1] = useState(null);
  const [branch2, setBranch2] = useState(null);
  const [period, setPeriod] = useState("yearly");

  /* ---------- API Calls ---------- */
  const getBranch1Stats = (id) => {
    if (!id) return;
    callApi({
      callback: () => branchStats(id, { period }),
      onSuccess: ({ data }) => setBranch1(data),
    });
  };

  const getBranch2Stats = (id) => {
    if (!id) return;
    callApi({
      callback: () => branchStats(id, { period }),
      onSuccess: ({ data }) => setBranch2(data),
    });
  };

  /* ---------- Branch List ---------- */
  useApi({
    callback: ListBranch,
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ list }) => setBranches(list || []),
  });

  /* ---------- Re-fetch on period change ---------- */
  useEffect(() => {
    if (branch1?.branch?._id) getBranch1Stats(branch1.branch._id);
    if (branch2?.branch?._id) getBranch2Stats(branch2.branch._id);
  }, [period]);

  return (
    <>
      <Button
        type="default"
        className="mb-2"
        style={{ color: "black" }}
        onClick={() => window.history.back()}
      >
        Back
      </Button>

      <Card title="Compare Branches">
        {/* -------- Period Filter -------- */}
        <Row gutter={16} className="mb-3">
          <Col>
            <Select
              value={period}
              onChange={setPeriod}
              style={{ minWidth: 180 }}
            >
              <Option value="weekly">Weekly</Option>
              <Option value="monthly">Monthly</Option>
              <Option value="yearly">Yearly</Option>
              <Option value="last5year">Last 5 Years</Option>
            </Select>
          </Col>
        </Row>

        <Row gutter={36} align="top" style={{ position: "relative" }}>
          {/* -------- Branch 1 -------- */}
          <Col span={12}>
            <Card
              title={
                <div className="new-branch-class">
                  <span>
                    Compare 1:{" "}
                    <b>{branch1?.branch?.name || "Select Branch"}</b>
                  </span>
                  <Select
                    onChange={getBranch1Stats}
                    style={{ minWidth: 200 }}
                  >
                    {branches.map((branch) => (
                      <Option key={branch._id} value={branch._id}>
                        {branch.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              }
            >
              <Table
                columns={[
                  { title: "Metric", dataIndex: "metric" },
                  { title: "Value", dataIndex: "value" },
                ]}
                dataSource={formatStats(branch1)}
                pagination={false}
                bordered
              />
            </Card>
          </Col>

          {/* -------- Divider -------- */}
          <div
            style={{
              width: "2px",
              backgroundColor: "rgb(255 108 62)",
              height: "100%",
              position: "absolute",
              top: 0,
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />

          {/* -------- Branch 2 -------- */}
          <Col span={12}>
            <Card
              title={
                <div className="new-branch-class">
                  <span>
                    Compare 2:{" "}
                    <b>{branch2?.branch?.name || "Select Branch"}</b>
                  </span>
                  <Select
                    onChange={getBranch2Stats}
                    style={{ minWidth: 200 }}
                  >
                    {branches.map((branch) => (
                      <Option key={branch._id} value={branch._id}>
                        {branch.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              }
            >
              <Table
                columns={[
                  { title: "Metric", dataIndex: "metric" },
                  { title: "Value", dataIndex: "value" },
                ]}
                dataSource={formatStats(branch2)}
                pagination={false}
                bordered
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default CompareBranches;
